export const GET_FOLDER_PERMISSION = 'GET_FOLDER_PERMISSION';
export const GET_FOLDER_PERMISSION_SUCCESS = 'GET_FOLDER_PERMISSION_SUCCESS';
export const GET_FOLDER_PERMISSION_FAILED = 'GET_FOLDER_PERMISSION_FAILED';